import { render, staticRenderFns } from "./chat-list.vue?vue&type=template&id=009c2459&scoped=true"
import script from "./chat-list.vue?vue&type=script&lang=js"
export * from "./chat-list.vue?vue&type=script&lang=js"
import style0 from "./chat-list.vue?vue&type=style&index=0&id=009c2459&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009c2459",
  null
  
)

export default component.exports